export default "__VITE_ASSET__qsf5IpnS__"